import React, { useEffect, useState, useCallback } from 'react';
import { getCookie } from '../services/session';

const SESSION_CHECK_INTERVAL = 10000; 

const Auth = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  // Session validation function
  const validateSession = useCallback(() => {
    const isLogged = localStorage.getItem('BMI-admin-is-logged');
    const sessionCookie = getCookie();

    if (!isLogged || !sessionCookie) {
      // Clear expired/missing session data
      localStorage.removeItem('BMI-admin-is-logged');
      // Explicitly delete the cookie (in case it's expired but still showing)
      const isSecure = window.location.protocol === 'https:';
      document.cookie = `BMI-admin-session=; path=/; max-age=0; SameSite=Strict${isSecure ? '; secure' : ''}`;
      // Set message for toast display on login page
      localStorage.setItem(
        'BMI-admin-message',
        'Session expired, please login again.'
      );
      // Use window.location.href for full page reload (ensures toast works)
      window.location.href = '/';
      return false;
    }
    return true;
  }, []);

  useEffect(() => {
    // Initial session check
    if (validateSession()) {
      setIsAuthenticated(true);
    }

    // Set up interval to periodically check session
    const intervalId = setInterval(() => {
      validateSession();
    }, SESSION_CHECK_INTERVAL);

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, [validateSession]);

  // Show nothing while checking auth (prevents flash)
  if (isAuthenticated === null) {
    return null;
  }

  return <>{children}</>;
};

export default Auth;

